<template>
    <div class="bg-gray-type-5 text-black">  
        <div class="flex sm:justify-center py-10 ">
            <div class="bg-white rounded-lg p-8 sm:w-[42.125rem]" @submit.prevent="createEvent" ref="form">
                <div class="text-left mb-2">
                    <h1 class="text-xl font-bold">Create an event</h1>
                    <p class="font-normal text-sm text-gray-4 pt-1">Tell us about your upcoming event</p>
                </div>
                <div class="flex flex-col justify-between py-2 lg:flex-row">
                    <div class="flex flex-col mb-2">
                        <label class="text-xs text-gray-4 pb-1">Name of event</label>
                        <input type="text" v-model="form.name" class="sm:w-[17.75rem] w-full h-12 border-solid border border-gray-type-9 rounded-lg px-3">
                        <p class="text-red-type-1 text-xs pt-1" v-if="$v.form.name.$error">This field is required</p>
                    </div>
                    <div class="flex flex-col">
                        <label class="text-xs text-gray-4 pb-1">Event type</label>
                        <input type="text"  v-model="form.type" class="sm:w-[17.75rem] w-full h-12 border-solid border border-gray-type-9 rounded-lg px-3">
                        <p class="text-red-type-1 text-xs pt-1" v-if="$v.form.type.$error">This field is required</p>
                    </div>
                </div>
                <div class="flex flex-col py-2">
                    <label class="text-xs text-gray-4 pb-1">Description</label> 
                    <tiptap v-model="form.description"></tiptap>
                    <p class="text-red-type-1 text-xs pt-1" v-if="$v.form.description.$error">This field is required</p>
                </div>
                <div class="flex flex-col justify-between py-2 lg:flex-row">
                    <div class="flex flex-col mb-2">
                        <label class="text-xs text-gray-4 pb-1">Location of event</label>
                        <route-location-selector
                            class="location-class"
                            @location-selected="(location) => (form.location = location)"
                        ></route-location-selector>
                        <p class="text-red-type-1 text-xs pt-1" v-if="$v.form.location.$error">This field is required</p>
                    </div>
                    <div class="flex flex-col">
                        <label class="text-xs text-gray-4 pb-1">Date of event</label>
                            <date-picker v-model="form.date" type="date" value-type="format" format="YYYY-MM-DD" range :disabled-date="disabledBeforeToday"></date-picker> 
                            <p class="text-red-type-1 text-xs pt-1" v-if="$v.form.date.$error">Please pick a date</p> 
                    </div>
                </div>
                <div class="flex flex-col justify-between py-2 lg:flex-row items-center">
                    <div class="flex flex-col">
                        <label
                        class="text-xs text-gray-4 pb-1" >Estimated number of attendees</label>
                        <input type="number" v-model="form.attendees" class="w-[22.813rem] h-12 border-solid border border-gray-type-9 rounded-lg px-3">
                        <p class="text-red-type-1 text-xs pt-1" v-if="$v.form.attendees.$error">This field is required</p>
                    </div>
                    <div class="set-aside w-full ml-2 mt-5">
                        <label class="switch">
                            <input type="checkbox" v-model="form.toandfro">
                            <span class="slider round"></span>
                        </label>   
                        <label class="pl-2 text-xs">Would you like us to take the attendees to and fro?</label>
                    </div>
                </div>
                <div class="py-2">
                    <label class="text-xs text-gray-4 pb-1">Event Banner</label>
                    <label class="custom-file-upload text-xs w-full py-6 rounded-lg text-center" v-if="showImage">
                        Drag or drop SVG, PNG, JPG or GIF (max. 800x400px)<br/><span class="text-bg-green-700">Click to browse</span>
                        <input type="file" accept="image/png, image/gif, image/jpeg ,image/svg" @change="onFileSelected">
                    </label>
                    <div v-if="processing" class="flex flex-col justify-center items-center my-2">
                        <spinner></spinner>
                        <span class="pt-1">Uploading..</span>
                    </div>
                    <div  class="flex" id="preview" v-if="uploaded">
                       <img class="imageDimensions mr-2" v-if="form.previewUrl" :src="form.previewUrl" />
                       <img src="@/assets/icons/close.svg" @click="removeImage()">
                    </div>
                </div>
                <div class="set-aside w-full ml-2 mt-5 py-2">
                    <input type="checkbox" v-model="form.attControl">
                    <label class="pl-2 text-xs w-3/4">
                        By clicking on this box, you agree that the attendees will be in full control of paying the bills for the event.
                        <p class="text-red-type-1 text-xs pt-1" v-if="$v.form.attControl.$error">Please agree</p>
                    </label>   
                </div>
                <div class="flex justify-center py-2">
                    <button
                    @click="createEvent()"
                      :disabled="$v.form.$invalid"
                      class="w-full inline-flex items-center justify-center p-2 text-black rounded-md bg-active"
                    >
                    {{ processingEvent ? 'Loading...' : `Submit request` }}</button>
                </div>
            </div>
        </div>
        <modal :show="showCheckoutModal" @close="showCheckoutModal = false" @click="showCheckoutModal = true" >
          <div class="relative px-6 py-3 pb-6 text-dark-type-4">
            <div class="mt-1 flex items-center flex-col">
                <div class="my-1">
                  <img src="@/assets/icons/refund-success.svg">
                </div>
                <div class="text-center">
                    <h3 class="text-lg font-normal text-dark-type-3">Event request was successful</h3>
                    <p class="text-base text-dark-type-4">
                        Your event was created successfully, our team would reach out to you once your request has been accepted.
                    </p>
                </div>
            </div>    
            <router-link  
            :to="{ name: 'dashboard.manage-event' }"
            class="block w-full h-12 py-4 mt-8 font-medium text-center text-black text-sm bg-active rounded"
            >Manage event</router-link>
         </div>  
        </modal>
    </div>
</template>

<script>
import axios from "@/services/axios";
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import required from "vuelidate/lib/validators/required";
import {validationMixin} from "vuelidate";
import Modal from '@/components/Modal.vue'
import Spinner from '@/components/Spinner.vue'
import RouteLocationSelector from "@/components/discover-routes/RouteLocationSelector.vue";
import Tiptap from "@/components/Tiptap.vue";

 export default{
    name: "CreateEvent",
    mixins: [validationMixin],
    components: { 
        DatePicker, 
        Modal,
        Spinner,
        RouteLocationSelector,
        Tiptap
     },
    data: () => {
        return {
            form:{
                name: '',
                type: '',
                description: '',
                location: '',
                date: [],
                attendees: '',
                image_url: null,
                previewUrl : null,
                toandfro: false,
                attControl: false,   
            },
            showCheckoutModal: false,
            showImage: true,
            processing: false,
            processingEvent: false,
            uploaded: false,

        }
    },
    validations:{
                form:{
                    name:{
                        required
                    },
                    type: {
                        required
                    },
                    description:{
                        required
                    },
                    location:{
                        required
                    },
                    date:{
                        required
                    },
                    attendees:{
                        required
                    },
                    attControl:{
                        required
                    }
                }
    },
    methods:{
     async onFileSelected(e){
            this.showImage = false
            const s3ImageUrl =  await this.uploadTos3andGetDocumentUrl(e.target.files[0]);
            this.form.image_url = s3ImageUrl
            this.form.previewUrl = URL.createObjectURL(e.target.files[0]);  
        },
        async uploadTos3andGetDocumentUrl(file) {
            this.processing = true 
            try {
                const formData = new FormData();
                    formData.append('file', file);
                    const response = await axios.post(
                    `/upload/identity/files`,
                    formData
                    );
                    if (response.data?.files?.length) {
                    return response.data.files[0].Location;
                    }
            } catch (error) {
                console.log(error)
                    this.$toast.warning(
                    'An error occured while uploading your file, please try again'
                    );
                } finally {
                this.processing = false
                this.uploaded = true
                console.log('uploading');
            }      
    },
     async createEvent(){
        this.$v.form.$touch();  
        this.processingEvent = true     
        try {
            await axios.post('https://api.test.shuttlers.africa/event/create', {
            "title": `${this.form.name}`,
            "type": `${this.form.type}`,
            "description": `${this.form.description}`,
            "location": `${this.form.location.label}`,
            "tripDate": `${this.form.date[0]}`,
            "returnDate": `${this.form.date[1]}`,
            "attendees": parseInt(this.form.attendees),
            "banner": `${this.form.image_url}`,
            "returnTrip": this.form.toandfro,
            "payment": this.form.attControl ? 'attendees' : 'organizer'   
            })
        } catch(err){
           if(err.response.status == 500){
            this.$toast.error("Oops an error occured, Please try again.");
           } else {
            this.$toast.error("Please contact support.")
           }
        } finally{
            this.processingEvent = false 
            this.$v.form.$reset();
            this.showCheckoutModal = true
        }
     },
     removeImage(){
       this.showImage = !this.showImage
       this.form.image_url = ''
       this.uploaded = !this.uploaded
     },
      disabledBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
      }
    }
 }
</script>

<style lang="scss">
@import '@/assets/css/switch';

.set-aside{
    display: grid;
    grid-template-columns: auto auto;
}

.mx-datepicker .mx-input {
    border: 1px solid #E5E9F2;
    border-radius: 8px;
    height: 48px;
}

.custom-file-upload {
      border: 1px dashed #B9BCC8;
      display: inline-block;
      cursor: pointer;
    input{
        display: none;
    }
    span{
        color: #0DAC5C;
        border-bottom: 1px solid #0DAC5C;
    }
}

button:disabled {
    background:#E5E9F2;
    color:#EFF2F7;
}

.created-modal{
    width: 400px
}

.imageDimensions {
     width: 556px;
     height: 88px;
     border-radius: 8px;
     object-fit: cover;
}

.location-class{
    span{
        display: none;
    }
    input{
        background: #FFFFFF;
        border: 1px solid #E5E9F2;
        border-radius: 8px;
        width: 17.75rem;
        padding: 0 12px;
        height: 3rem;
        font-weight: 500;
        color: #0F100F;
    }
}

@media only screen and (max-width: 425px) {
    .mx-input{
        width: 365px;
    }
    .mx-datepicker-range{
        width: 350px;
    }
    .location-class{
        input{
            width: 100%;
        }
    }
}
</style>